import { render, staticRenderFns } from "./mensagemAlerta.vue?vue&type=template&id=09aab550"
import script from "./mensagemAlerta.vue?vue&type=script&lang=js"
export * from "./mensagemAlerta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports